import logo from '../../assets/logoproxy.png';
import './PageLoader.css';

const PageLoader = () => (
  <div className="page-loader" role="status" aria-label="Chargement…">
    <div className="page-loader__logo">
      <img src={logo} alt="POINTPAY" className="logo-img" />
    </div>

    <div className="page-loader__bar" aria-hidden="true">
      <div className="page-loader__bar-fill" />
    </div>
  </div>
);

export default PageLoader;
